import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SharedModule } from 'src/app/shared/shared.module';
import { ElenchiComponent } from './elenchi.component';

@NgModule({
  imports: [
    ReactiveFormsModule,
    SharedModule,
    SelectButtonModule
  ],
  exports: [
    ElenchiComponent
  ],
  declarations: [
    ElenchiComponent
  ],
  providers: [],
})
export class ElenchiModule { }
